import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import { Dialog, Filters, Pagination, SingleAction, Sort } from "../types";

const paymentRecoverySectionUrl = "/payment-recovery";

export const checkoutListPath = paymentRecoverySectionUrl;

/**
 * Only what Saleor can actually order by. Note `status` maps to Saleor's
 * PAYMENT sort, which is `last_charge_status` — a charge-state ordering, not an
 * amount one. "Money held" is summed client-side from the transactions, so it
 * is deliberately not sortable: a header that reordered rows by something other
 * than the number under it would just mislead.
 */
export enum CheckoutListUrlSortField {
  date = "date",
  customer = "customer",
  status = "status",
}

export enum CheckoutListUrlFiltersEnum {
  query = "query",
}

export type CheckoutListUrlFilters = Filters<CheckoutListUrlFiltersEnum>;
export type CheckoutListUrlSort = Sort<CheckoutListUrlSortField>;
export type CheckoutListUrlQueryParams = CheckoutListUrlFilters & CheckoutListUrlSort & Pagination;

export const checkoutListUrl = (params?: CheckoutListUrlQueryParams): string => {
  if (params === undefined) {
    return checkoutListPath;
  }

  return urlJoin(checkoutListPath, "?" + stringifyQs(params));
};

export const checkoutPath = (id: string) => urlJoin(paymentRecoverySectionUrl, id);

export type CheckoutUrlDialog = "create-order" | "refund";
export type CheckoutUrlQueryParams = Dialog<CheckoutUrlDialog> & SingleAction;

export const checkoutUrl = (id: string, params?: CheckoutUrlQueryParams): string => {
  const checkout = checkoutPath(encodeURIComponent(id));

  if (params === undefined) {
    return checkout;
  }

  return urlJoin(checkout, "?" + stringifyQs(params));
};
